// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/ReportService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { ReportOutputDtoSchema, TrackingReportInputDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/ReportService.proto.
 */
export const file_Services_ReportService: GenFile = /*@__PURE__*/
  fileDesc("ChxTZXJ2aWNlcy9SZXBvcnRTZXJ2aWNlLnByb3RvMsMBCg1SZXBvcnRTZXJ2aWNlErEBChZHZW5lcmF0ZVRyYWNraW5nUmVwb3J0EjQudGltZV90cmFja2luZy5tZXNzYWdlcy5iYXNpYy5UcmFja2luZ1JlcG9ydElucHV0RHRvGi0udGltZV90cmFja2luZy5tZXNzYWdlcy5iYXNpYy5SZXBvcnRPdXRwdXREdG8iMqDazQ8CgtPkkwInOgEqIiIvYXBpL3JlcG9ydC9nZW5lcmF0ZVRyYWNraW5nUmVwb3J0QiSqAiFNb2dpLlRpbWVUcmFja2luZy5Db21tb24uU2VydmljZXNiBnByb3RvMw", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Options_MethodOptions]);

/**
 * Service for generating reports.
 *
 * @generated from service ReportService
 */
export const ReportService: GenService<{
  /**
   * Generate a report about trackings of projects.
   *
   * @generated from rpc ReportService.GenerateTrackingReport
   */
  generateTrackingReport: {
    methodKind: "unary";
    input: typeof TrackingReportInputDtoSchema;
    output: typeof ReportOutputDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_ReportService, 0);

